"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOrderReminder = void 0;
const addOrderReminder = async (supabase, obj) => {
    const { data, error } = await supabase.from("reminders").insert([obj]);
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.addOrderReminder = addOrderReminder;
